import { TimelineStep } from '../types';
import { Language } from '../i18n/translations';

export const getTimelineSteps = (language: Language): TimelineStep[] => {
  const steps = {
    en: [
      {
        id: 'analyze',
        title: 'Analyze',
        duration: 'Discovery Call',
        description: 'We jump on a video call to deeply understand your company\'s workflow, pain points, and bottlenecks. Together, we identify the repetitive tasks draining your team\'s time and develop a customized automation plan tailored to your specific needs.',
        icon: '🔍'
      },
      {
        id: 'build',
        title: 'Build POC',
        duration: 'Proof of Concept',
        description: 'We create a working Proof of Concept (POC) - a functional prototype of your automation solution. This isn\'t just a mockup; it\'s a real, working example that demonstrates exactly how the automation will handle your workflow, process your data, and deliver results.',
        icon: '⚙️'
      },
      {
        id: 'deliver',
        title: 'Deliver',
        duration: 'Video Walkthrough',
        description: 'You receive a personalized video walkthrough showcasing your custom automation solution in action. We explain how it works, demonstrate the time and cost savings, and highlight the specific benefits for your business - all before you make any commitment.',
        icon: '🎥'
      }
    ],
    es: [
      {
        id: 'analyze',
        title: 'Analizar',
        duration: 'Llamada de Descubrimiento',
        description: 'Realizamos una videollamada para entender profundamente el flujo de trabajo de tu empresa, puntos de dolor y cuellos de botella. Juntos, identificamos las tareas repetitivas que drenan el tiempo de tu equipo y desarrollamos un plan de automatización personalizado adaptado a tus necesidades específicas.',
        icon: '🔍'
      },
      {
        id: 'build',
        title: 'Construir POC',
        duration: 'Prueba de Concepto',
        description: 'Creamos una Prueba de Concepto (POC) funcional - un prototipo funcional de tu solución de automatización. No es solo una maqueta; es un ejemplo real y funcional que demuestra exactamente cómo la automatización manejará tu flujo de trabajo, procesará tus datos y entregará resultados.',
        icon: '⚙️'
      },
      {
        id: 'deliver',
        title: 'Entregar',
        duration: 'Video Tutorial',
        description: 'Recibes un video tutorial personalizado mostrando tu solución de automatización personalizada en acción. Explicamos cómo funciona, demostramos los ahorros de tiempo y costos, y destacamos los beneficios específicos para tu negocio - todo antes de que hagas cualquier compromiso.',
        icon: '🎥'
      }
    ]
  };

  return steps[language];
};
